export default __webpack_public_path__ + "static/media/clear.822cbab4.svg";